<script lang="ts">import { faqs } from "../data/index";
import VipRankRewards from "../icons/faqs.png";
import { getVerbiageKey } from "../utils";
import { Accordion } from "@infinitro/accordion";
import { cfgToThemeContentPath, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { locale } from "@infinitro/global";
import { Text } from "@infinitro/text";
import MarkdownIt from "markdown-it";
import VipTitle from "./alternative2/vip-title.svelte";
const md = new MarkdownIt({
	html: true,
	breaks: true,
	linkify: true
});
$: useAlternative = $stateUi.vip.vipAboutStyle === "alternative";
$: useAlternative2 = $stateUi.vip.vipAboutStyle === "alternative2";
$: useMarkdownFaqs = $stateUi.vip.useMarkdownFaqs;
let mdFaqs = [];
function parseMarkdownFaqs(text) {
	const sections = text.split(/^## /m).filter((s) => s.trim());
	return sections.map((section) => {
		const lines = section.split("\n");
		const question = lines[0].trim();
		const answerMd = lines.slice(1).join("\n").trim();
		return {
			question,
			answer: md.render(answerMd)
		};
	});
}
async function fetchMarkdownFaqs(loc) {
	try {
		const url = cfgToThemeContentPath(`/vip/faqs.${loc}.md`);
		const response = await fetch(url);
		if (!response.ok) {
			if (loc !== "en") {
				console.warn("Falling back to English FAQ content...");
				await fetchMarkdownFaqs("en");
				return;
			}
			throw new Error(`Error fetching FAQ content: ${response.statusText}`);
		}
		const text = await response.text();
		mdFaqs = parseMarkdownFaqs(text);
	} catch (error) {
		console.warn("Failed to fetch FAQ markdown:", error);
		mdFaqs = [];
	}
}
$: if (useMarkdownFaqs) {
	fetchMarkdownFaqs($locale);
}
</script>

<div class="faqs-container">
	{#if useAlternative}
		<div class="title-wrap-alternative">
			<h1>
				{$t(Verbiage[getVerbiageKey('vip_faqs')])}
			</h1>
		</div>
	{:else if useAlternative2}
		<VipTitle title="FAQs" />
	{:else}
		<div class="faqs-badge">
			<img src={VipRankRewards} alt={$t(Verbiage.star_alt, 'alts')} />
			<Text type="body" bodySize="small">FAQ</Text>
		</div>
		<Text type="title" titleSize="h3" customStyle="margin-bottom: 1rem" textAlign="center">
			{$t(Verbiage[getVerbiageKey('frequently_asked_questions_text')])}
		</Text>
	{/if}

	<div class="faqs-grid">
		{#if useMarkdownFaqs}
			{#each mdFaqs as faq (faq.question)}
				<Accordion isHtml={true} title={faq.question} text={faq.answer} />
			{/each}
		{:else}
			{#each faqs as faq (faq.question)}
				<Accordion
					isHtml={true}
					title={$t(Verbiage[faq.question])}
					text={$t(Verbiage[faq.answer])}
					additionalContent={faq.additionalContent}
				/>
			{/each}
		{/if}
	</div>
</div>

<style>
	.title-wrap-alternative {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
	.title-wrap-alternative h1 {
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 1px
}
	.title-wrap-alternative h2 {
    margin-bottom: 0.75rem;
    font-size: 0.875rem;
    line-height: 1.25rem
}
	.faqs-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem
}

	.faqs-grid {
    margin-top: 1rem;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 1rem
}

	.faqs-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    border-radius: 9999px;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    background: var(--gradient-main)
}
</style>
